import React, { Component } from "react";
import { connect } from "react-redux";
import { Navbar } from "../components/Navbar";
import { withRouter } from "react-router-dom";
import { logout } from "../redux/actions/userActions";
import logAnalyticsEvent from "../utils/logAnalyticsEvent";

export class NavbarContainer extends Component {
  state = { appsOpen: false };

  onAppsClick = () => this.setState({ appsOpen: !this.state.appsOpen });

  render() {
    const {
      user,
      authenticated,
      location: { pathname },
      logout,
      history
    } = this.props;
    
    logAnalyticsEvent("page_location", {pathname});

    return (
      <Navbar
        signIn={authenticated}
        role={user.role}
        pathname={pathname}
        onAppsClick={this.onAppsClick}
        appsOpen={this.state.appsOpen}
        onLogout={() => logout(history)}
      />
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
  authenticated: state.user.authenticated
});

const mapDispatchToProps = { logout };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NavbarContainer));
